import React, { useCallback, useState } from "react";
import { ItemRenderProps, TreeView } from "@progress/kendo-react-treeview";
import { TreeViewProps } from "@progress/kendo-react-treeview/dist/npm/TreeViewProps";
import { TreeItemRow } from "./TreeItemRow";
import { TreeItemRowProps } from "./TreeItemRowUtils";

export type CustomTreeViewProps = Omit<TreeViewProps, "item"> & {
  treeItemRowProps: Omit<TreeItemRowProps, "item" | "itemHierarchicalIndex" | "isSelected">;
  selectedItemId: string;
};

export const CustomTreeView = (props: CustomTreeViewProps) => {
  const [paths, setPaths] = useState<Map<string, string>>(new Map());
  const setPathForItem = useCallback((itemId: string, path: string) => setPaths((m) => m.set(itemId, path)), [paths]);
  const getPathForItem = useCallback((itemId: string) => paths.get(itemId), [paths]);

  const renderItemTree = useCallback(
    (input: ItemRenderProps) => (
      <TreeItemRow
        {...input}
        isSelected={props.selectedItemId === input.item.key}
        {...props.treeItemRowProps}
        pathInfo={{
          setPathForItem,
          getPathForItem,
        }}
      />
    ),
    [props.selectedItemId, props.treeItemRowProps]
  );

  return <TreeView {...props} item={renderItemTree} />;
};
